// extracted by mini-css-extract-plugin
export default {"mainContainer":"CentralRegistry_mainContainer__rRxBP","buttonContainer":"CentralRegistry_buttonContainer__9s4x6","buttonContainer2":"CentralRegistry_buttonContainer2__HMHmr"};